export {};
//# sourceMappingURL=type-help-options.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/class-transformer/esm5/interfaces/type-help-options.interface.js
// module id = 802
// module chunks = 3